import { STATUS_LABEL } from '../../constants';
import { useAuth } from '../../store';
import s from '../../styles/dashboard.module.css';

// Draggable staff member card in the sidebar; drag onto a card to assign.
// Only admins can drag (assign); everyone else sees a read-only card.
export function StaffMemberCard({ member, tipCents }) {
  const { user }    = useAuth();
  const canDrag     = user?.role === 'admin';
  const statusColor = {
    available: 'var(--success)', busy: 'var(--accent)', break: 'var(--text-faint)',
  };
  const dotColor    = statusColor[member.status] || 'var(--text-faint)';
  const memberName  = `${member.given_name || ''} ${member.family_name || ''}`.trim();
  const initials    = memberName.split(' ').filter(Boolean).map(n => n[0]).join('').toUpperCase();

  return (
    <div draggable={canDrag}
         onDragStart={canDrag ? (e => { e.dataTransfer.setData('memberId', member.externalId); e.dataTransfer.effectAllowed = 'copy'; }) : undefined}
         className={s.staffCard}>
      {canDrag && <div className={s.staffDragHandle}>⠿</div>}
      <div className={s.staffInitialBubble}>{initials}</div>
      <div className={s.staffInfo}>
        <div className={s.staffNameText}>{memberName}</div>
      </div>
      {/* Today's share of tips from every car this member is assigned to. */}
      <div className={tipCents ? s.staffTip : s.staffTipNone}>
        {tipCents ? `$${(tipCents / 100).toFixed(2)}` : '—'}
      </div>
    </div>
  );
}
